import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';

import { FuseConfigService } from '@fuse/services/config.service';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';

import { navigation } from 'app/navigation/navigation';
import { AuthService } from '@bya/auth/services/authentication.service';
import { VigenciaSistemaService } from 'app/services/vigencia-sistema.service';
import { VigenciaFiscalService } from 'app/main/datos-basicos/services/vigencia-fiscal-service.service';
import { VigenciaFiscal } from 'app/main/datos-basicos/models/vigencia-fiscal';
import { MatDialog } from '@angular/material/dialog';
import { LoadingComponent } from 'app/common/loading/loading.component';
import { ChangePasswordModalComponent } from 'app/layout/change-password-user/components/change-password-modal/change-password-modal.component';
import { AppConfigService } from 'app/services/app-config/app-config.service';
import { UserService } from '../../services/user.service';
import { EditarDatosPersonalesService } from 'app/main/home/service/editar-datos-personales.service';
import { AlertDialogComponent } from 'app/common/alert-dialog/alert-dialog.component';
import { TerceroRegistroModalComponent } from 'app/main/datos-basicos/modules/tercero-registro/tercero-registro-modal/tercero-registro-modal.component';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector     : 'toolbar',
    templateUrl  : './toolbar.component.html',
    styleUrls    : ['./toolbar.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ToolbarComponent implements OnInit, OnDestroy
{
    horizontalNavbar: boolean;
    rightNavbar: boolean;
    hiddenNavbar: boolean;
    languages: any;
    navigation: any;
    selectedLanguage: any;
    userStatusOptions: any[];

    //@bya Open id Connect Security
    name: string;
    nombreCompleto: string;
    isAuthenticated: string;
    subscription: Subscription;
    logUltimoLogin: any;

    //@bya Vigencia del sistema
    vigencias: VigenciaFiscal[];
    vigenciaSistema: VigenciaFiscal;


    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FuseSidebarService} _fuseSidebarService
     * @param {TranslateService} _translateService
     * @param {AuthService} _authService
     */
    constructor(
        private _fuseConfigService: FuseConfigService,
        private _fuseSidebarService: FuseSidebarService,
        private _translateService: TranslateService,
        private authService: AuthService, 
        public _vigenciaSistemaService: VigenciaSistemaService, 
        private _vigenciaFiscalService: VigenciaFiscalService,
        private _matDialog: MatDialog,
        private _matSnackbar:MatSnackBar,
        private _appConfig: AppConfigService,
		private _userService: UserService,
        private editarDatosPersonalesService:EditarDatosPersonalesService
    )
    {
        // Set the defaults
        this.userStatusOptions = [
            {
                title: 'Online',
                icon : 'icon-checkbox-marked-circle',
                color: '#4CAF50'
            },
            {
                title: 'Away',
                icon : 'icon-clock',
                color: '#FFC107'
            },
            {
                title: 'Do not Disturb',
                icon : 'icon-minus-circle',
                color: '#F44336'
            },
            {
                title: 'Invisible',
                icon : 'icon-checkbox-blank-circle-outline',
                color: '#BDBDBD'
            },
            {
                title: 'Offline',
                icon : 'icon-checkbox-blank-circle-outline',
                color: '#616161'
            }
        ];

        this.languages = [
            {
                id   : 'en',
                title: 'English',
                flag : 'us'
            },
            {
                id   : 'tr',
                title: 'Turkish',
                flag : 'tr'
            }
        ];

        this.navigation = navigation;

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    //@ bya
    ///
    private subscribeAuthService() {
        this.subscription = this.authService.authNavStatus$.subscribe(reportAuth => {
            
            this.isAuthenticated = reportAuth.status;
            if (reportAuth.user) 
            {
                this.getVigencias();
                this.name = reportAuth.user.profile.name;
				this.nombreCompleto = reportAuth.user.profile.given_name;
            }  

            if (this.isAuthenticated== 'true') {
                this.getUltimoInicioSesion();
            }
        });

        // this.authService.givenNameAsync.subscribe(nombre => {
        //     this.nombreCompleto = nombre;
        // });

    }

    getVigencias(): void {
        let loading = this._matDialog.open(LoadingComponent, { panelClass: 'loading' });
        this._vigenciaFiscalService.getAll()
        .subscribe(vigencias => {
            if (this._vigenciaSistemaService.vigencia == null) {
            	var vigenciaActiva = vigencias.find((t) => { return t.estado == "AC" });
				this._vigenciaSistemaService.establecerVigencia(vigenciaActiva);
            }else{
                this.vigenciaSistema = this._vigenciaSistemaService.vigencia;
            }
            this.vigencias = vigencias;
            loading.close();
        });
    }

    getUltimoInicioSesion() {
        this._userService.GetUltimoInicioSesion().subscribe(t => {
            this.logUltimoLogin = t;
        });
    }

    seleccionarVigencia(vigenciaNueva: VigenciaFiscal){
        if(this.vigenciaSistema == null || this.vigenciaSistema.id != vigenciaNueva.id){
            this._vigenciaSistemaService.establecerVigencia(vigenciaNueva);
        }
    }

    signout() {
        this.authService.signout();
    }

    CambiarPassword(){
        // Identity II tiene su propia pantalla de cambio de contraseña (centro de cuenta); el returnUrl
        // (origen de SIRCC, registrado en el cliente) habilita el enlace de regreso.
        window.location.href = `${this.urlIdentity()}/Account/Contrasena?returnUrl=${encodeURIComponent(window.location.origin + '/')}`;
    }

    // Centro de cuenta de Identity II (contraseña, correo y llaves de acceso si el ambiente las habilita).
    IrAMiCuenta() {
        window.location.href = `${this.urlIdentity()}/Account?returnUrl=${encodeURIComponent(window.location.origin + '/')}`;
    }

    public EsAdministrador():boolean{
        // Identity II autoriza su consola con Identity_AdminCentral, Identity_Soporte o cualquier
        // Identity_Admin_{Aplicacion}; IdentityApi_Seguridad es el rol del Identity legacy.
        return this.authService.hasRole("IdentityApi_Seguridad")
            || this.authService.hasRole("Identity_AdminCentral")
            || this.authService.hasRole("Identity_Soporte")
            || this.authService.hasRoleStartingWith("Identity_Admin_");
    }
    public IrAIdenityAdmin(){
        window.open(`${this.urlIdentity()}/AdminUsuarios`);
    }

    // IdentityAdminUrl sin barra final, para poder concatenar rutas sin dejar "//".
    private urlIdentity(): string {
        return (this._appConfig.IdentityAdminUrl || '').replace(/\/+$/, '');
    }

    private unSubscribeAuthService() {
        // prevent memory leak when component is destroyed
        this.subscription.unsubscribe();
    }


    /// End @bya 


    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        // Subscribe to the config changes
        this._fuseConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((settings) => {
                this.horizontalNavbar = settings.layout.navbar.position === 'top';
                this.rightNavbar = settings.layout.navbar.position === 'right';
                this.hiddenNavbar = settings.layout.navbar.hidden === true;
            });

        // Set the selected language from default languages
        this.selectedLanguage = _.find(this.languages, { id: this._translateService.currentLang });

        this.subscribeAuthService();
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
        this.unSubscribeAuthService();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle sidebar open
     *
     * @param key
     */
    toggleSidebarOpen(key): void
    {
        this._fuseSidebarService.getSidebar(key).toggleOpen();
    }

    /**
     * Search
     *
     * @param value
     */
    search(value): void
    {
        // Do your search here...
        console.log(value);
    }

    /**
     * Set the language
     *
     * @param lang
     */
    setLanguage(lang): void
    {
        // Set the selected language for the toolbar
        this.selectedLanguage = lang;

        // Use the selected language for translations
        this._translateService.use(lang.id);
    }

    public ActualizarDatos(){
        this.getDatosUsuario(result => {
            if(!result.isValid) return;
            this._matDialog.open(TerceroRegistroModalComponent,{
                panelClass: 'tercero-registro-form-dialog',
                data: {
                    action: 'editar',
                    terceroId: result.terceroId
                }
            })
            .afterClosed()
            .subscribe(result => {
                if(!result) return;
                this._matSnackbar.open(result.mensaje, 'Entendido', {duration: 4500});
            })
        })
    }

    private getDatosUsuario(callback){
		const loading = this._matDialog.open(LoadingComponent).addPanelClass('loading');
		this.editarDatosPersonalesService.GetTercero()
		.subscribe(response => {
			loading.close();
			if(!response){
                callback({isValid:false, terceroId:0});
                return;
            }
			callback({isValid:true, terceroId: response.id});
		})
	}
}
